import * as React from 'react';
import { Tooltip } from '@patternfly/react-core';
import { MobileViewContext } from '@app/AppLayout/MobileViewContext';

/** Visible characters before an ellipsis. Full text is shown on hover. */
export const LABEL_TRUNCATE_AT = 11;

export interface TruncatedLabelProps {
  content: string;
  className?: string;
}

const TruncatedLabel: React.FunctionComponent<TruncatedLabelProps> = ({ content, className }) => {
  const isMobileView = React.useContext(MobileViewContext);

  if (isMobileView || content.length <= LABEL_TRUNCATE_AT) {
    return <span className={className}>{content}</span>;
  }

  return (
    <Tooltip content={content} position="top">
      <span className={className} tabIndex={0}>
        {`${content.slice(0, LABEL_TRUNCATE_AT)}…`}
      </span>
    </Tooltip>
  );
};

export { TruncatedLabel };
